import React from 'react'

const Cancellation = () =>
  <div>
    <h1>Políticas de cancelación</h1>
    <p>lorem ipsum</p>
  </div>

export default Cancellation
